import { getGeolocation } from "../../api/geolocation";
import { getCookie, setCookie } from "../../utils/analytics";
import CalculateNearestPlacesService from "./calculateNearestPlacesService";

async function getNearestPlaces() {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (
    getCookie("geolocation-v2") &&
    !isSafari &&
    getCookie("geolocation-v2-location-sf")
  ) {
    return Promise.resolve(JSON.parse(getCookie("geolocation-v2")));
  } else {
    const geoData = await getGeolocation();
    if (geoData.status !== "fail") {
      let nearestPlaces = new CalculateNearestPlacesService(geoData);
      nearestPlaces.calculateNearest();

      setCookie("geolocation-v2", nearestPlaces.nearest, 1);

      const locationID = nearestPlaces.nearest.locations_checkout[0].id;
      const locationSF_ID =
        nearestPlaces.nearest.locations_checkout[0].salesforce_id;
      setCookie("geolocation-v2-location", locationID, 1);
      setCookie("geolocation-v2-location-sf", locationSF_ID, 1);

      // const url = window.location.origin + `/wp-json/v2/locations?location_id=${locationID}&data=salesforce_id`;
      // console.log(url)
      // fetch(url)
      //   .then((response) => response.json())
      //   .then((data) => {
      //   });

      setCookie("ind_geodata", nearestPlaces.geoData, 1);
      return nearestPlaces.nearest;
    } else {
      // hide loaders
      $(".loader").addClass("d-none");
    }
  }
}

export default getNearestPlaces;
